module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Medium.9d46d938.woff2";